import gif from '../img/x.gif'

const AIloader = () => {
    return (
        <img
            src={gif}
            alt='ai dark mode gif animation'
            style={{
                width: '40%',
                height: '40%',
                objectFit: 'contain'
            }}
        />
    )
}

export default AIloader
